import { Button as ButtonComponent } from "@headlessui/react";
import clsx from "clsx";

const Button = ({ children, className, variant = "primary", ...props }) => {
  const variantStyles = {
    primary: "bg-[#0B1120] text-white hover:bg-blue-600 shadow-lg shadow-blue-900/20",
    secondary: "border border-slate-200 text-gray-700 hover:bg-slate-900 hover:text-white",
    outline: "border border-gray-200 hover:bg-gray-50 text-gray-700",
    danger: "bg-red-500 text-white hover:bg-red-600 shadow-sm",
    success: "bg-green-500 text-white hover:bg-green-600 shadow-sm",
    warning: "bg-yellow-500 text-white hover:bg-yellow-600 shadow-sm",
    info: "bg-blue-600 text-white hover:bg-blue-700 shadow-sm",
    light: "bg-gray-50 hover:bg-gray-100 text-gray-700 shadow-sm",
    dark: "bg-[#0B1120] text-white hover:bg-gray-800 shadow-sm",
  };

  return (
    <ButtonComponent
      className={clsx(
        "inline-flex items-center justify-center gap-2 rounded-xl px-4 py-2.5 text-sm font-medium cursor-pointer",
        variantStyles[variant],
        "focus:outline-none focus:ring-2 focus:ring-blue-500/10",
        "disabled:opacity-50 disabled:cursor-not-allowed",
        "transition-all duration-300 ease-[cubic-bezier(0.16,1,0.3,1)]",
        className
      )}
      {...props}
    >
      {children}
    </ButtonComponent>
  );
};

export default Button;
